import React, { useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';

export default function PhotosTab({ photos }) {
  const [isOpen, setisOpen] = useState(false);
  const [currentImage, setcurrentImage] = useState(null);

  const toggleLightbox = (filePath) => {
    setisOpen((prev) => !prev);
    const uri = `${process.env.REACT_APP_API_URL}/${filePath}`
    setcurrentImage(uri);
  }

  return (
    <Container className="px-0">
      <Row>
        {photos.map((file, index) => (
          <Col key={index} xs={6} md={4} lg={3} className='photoGalleryCard'>
            <Image
              src={`${process.env.REACT_APP_API_URL}/${file?.filePath}`}
              alt={`Photo ${index + 1}`}
              className="w-100 h-100 object-fit-cover gallery-img"
              onClick={() => toggleLightbox(file?.filePath)}
            />
          </Col>
        ))}
      </Row>

      {isOpen && (
        <Lightbox
          mainSrc={currentImage}
          onCloseRequest={toggleLightbox}
          imageTitle="Project 1"
        />
      )}
    </Container>
  );
}

